import { render, staticRenderFns } from "./ltindex.vue?vue&type=template&id=05fba415&scoped=true&"
import script from "./ltindex.vue?vue&type=script&lang=js&"
export * from "./ltindex.vue?vue&type=script&lang=js&"
import style0 from "./ltindex.vue?vue&type=style&index=0&id=05fba415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fba415",
  null
  
)

export default component.exports